module.exports = __webpack_public_path__ + "static/media/menu.aeb37b11.svg";